module.exports = __webpack_public_path__ + "static/media/008.9bb84754.jpg";